import { mapGetters, mapActions } from "vuex";

const TeachersInClass = {
  computed: {
    ...mapGetters(["getCurrentClass", "getClassTeachers"]),
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      teacher_count: null,
      teacher_data: [],
      num_counter: 0,
    };
  },

  watch: {
    num_counter: "checkClassTeacherState",
  },

  mounted() {
    if (this.account_type === "school") this.checkClassTeacherState();
  },

  methods: {
    ...mapActions(["getTeachersInClass", "setClassTeachers"]),

    toggleTeacherModal() {
      this.teacher_modal = !this.teacher_modal;
    },

    checkClassTeacherState() {
      if (this.getClassTeachers.length > 1) {
        // ALSO CHECK IF THE FIRST OBJECT IS HAVING SAME CLASS ID AS CURRENT CLASS
        if (
          Number(this.getClassTeachers[0].class_id) === this.getCurrentClass
        ) {
          this.teacher_data = this.getClassTeachers;
          this.teacher_count = this.getClassTeachers.length;
        } else {
          this.fetchClassTeachers();
        }
      } else {
        this.fetchClassTeachers();
      }
    },

    fetchClassTeachers() {
      this.teacher_data = [];
      this.getTeachersInClass(this.getCurrentClass)
        .then((response) => {
          if (response.code === 200) {
            response.data.map((teacher) => {
              let teacher_obj = {};
              teacher_obj.class_id = Number(this.getCurrentClass);
              teacher_obj.teacher_id = teacher.id;
              teacher_obj.fullname = teacher.full_name;
              teacher_obj.image = teacher.image;
              teacher_obj.subjects = [];

              teacher.teacherSubjects.map((subject) => {
                teacher_obj.subjects.push(subject.name);
              });

              this.teacher_data.push(teacher_obj);
            });
            this.teacher_count = this.teacher_data.length;

            // SET TEACHER DATA TO STATE
            this.setClassTeachers(this.teacher_data);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};

export default TeachersInClass;
